module.exports = __webpack_public_path__ + "6dc3b160c4db2e444fd1baad9a797d27.pdf";